import type {Mapper} from 'framework';
import type {MeasurementEntry} from '../../domain/measurement-entry';
import type {MeasurementEntryDto} from '../dto/body-measurements.dto';

const toDate = (value: string | Date): Date => (value instanceof Date ? value : new Date(value));

export class MeasurementEntryDtoToMeasurementEntryMapper implements Mapper<
  MeasurementEntryDto,
  MeasurementEntry
> {
  transform(dto: MeasurementEntryDto): MeasurementEntry {
    return {
      id: dto.id,
      metricId: dto.metricId,
      measuredOn: dto.measuredOn,
      valueCm: dto.valueCm,
      createdAt: toDate(dto.createdAt),
      updatedAt: toDate(dto.updatedAt),
    };
  }
}
